import {GET_CUSTOMER_LIST, UPDATE_CUSTOMER_NOTE, GET_CUSTOMER_HISTORY} from "./customerTypes";

export default {
  [GET_CUSTOMER_LIST](state, data) {
    state.customerList = data;
  },
  [UPDATE_CUSTOMER_NOTE](state, data) {
    for(let i = 0; i< state.customerList.length; i++) {
      if(state.customerList[i].id == data.id) {
        state.customerList[i].note = data.note;
        return;
      }
    }
  },
  [GET_CUSTOMER_HISTORY](state, data){
    state.customerHistory = data;
  }
}
